import { BoxProps } from "components/box"
import { TypographyProps } from "theme/typography"
export * from "./headers"
export * from "./content"
export * from "./links"

export type TextProps = {
  children?: React.ReactNode
  /** Waiting for this to resolve: https://github.com/microsoft/TypeScript/issues/34933 */
  as?: any
  htmlFor?: string
  strikethrough?: boolean
  bold?: boolean
  italic?: boolean
  upperCase?: boolean
  onClick?: () => void
  dangerouslySetInnerHTML?: {
    __html: string
  }
} & BoxProps &
  TypographyProps
